import React from "react";

function CartSkeletonLoader() {
  return (
    <div className="animate-pulse mt-24">
      {/* Cart Page Title Skeleton */}
      <div className="h-8 w-40 bg-gray-200 rounded mb-6"></div>
      
      <div className="flex flex-col md:flex-row gap-6">
        {/* Cart Items Skeleton - Left Side */}
        <div className="flex-1">
          {/* Multiple Product Items */}
          {[1, 2, 3].map((item) => (
            <div key={item} className="flex mb-6 border-b pb-6">
              {/* Product Image Skeleton */}
              <div className="w-28 h-28 bg-gray-200 rounded mr-4"></div>
              
              {/* Product Details Skeleton */}
              <div className="flex-1">
                {/* Product Title and Delete Button */}
                <div className="flex justify-between mb-2">
                  <div className="h-5 w-2/3 bg-gray-200 rounded"></div>
                  <div className="h-6 w-6 bg-gray-200 rounded-full"></div>
                </div>
                
                {/* Price */}
                <div className="h-5 w-20 bg-gray-200 rounded mb-3"></div>
                
                {/* Product Details */}
                <div className="space-y-2 mb-4">
                  <div className="h-4 w-40 bg-gray-200 rounded"></div>
                  <div className="h-4 w-32 bg-gray-200 rounded"></div>
                  <div className="h-4 w-24 bg-gray-200 rounded"></div>
                </div>
                
                {/* Cart Buttons */}
                <div className="flex gap-2">
                  <div className="h-8 w-10 bg-gray-200 rounded"></div>
                  <div className="h-8 w-16 bg-gray-200 rounded"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {/* Order Summary Skeleton - Right Side */}
        <div className="w-full md:w-80">
          <div className="border rounded-md p-4">
            {/* Order Value Section */}
            <div className="space-y-4 mb-4">
              <div className="flex justify-between">
                <div className="h-4 w-20 bg-gray-200 rounded"></div>
                <div className="h-4 w-16 bg-gray-200 rounded"></div>
              </div>
              <div className="flex justify-between">
                <div className="h-4 w-16 bg-gray-200 rounded"></div>
                <div className="h-4 w-12 bg-gray-200 rounded"></div>
              </div>
            </div>
            
            {/* Total Section */}
            <div className="border-t pt-4 mb-4">
              <div className="flex justify-between mb-4">
                <div className="h-5 w-12 bg-gray-200 rounded"></div>
                <div className="h-5 w-20 bg-gray-200 rounded"></div>
              </div>
              
              {/* Checkout Button */}
              <div className="h-10 w-full bg-gray-200 rounded mb-6"></div>
            </div>
            
            {/* Payment Info Section */}
            <div className="space-y-3">
              <div className="h-4 w-20 bg-gray-200 rounded"></div>
              <div className="flex gap-2">
                {[1, 2, 3, 4].map(item => (
                  <div key={item} className="h-8 w-10 bg-gray-200 rounded"></div>
                ))}
              </div>
              <div className="h-24 w-full bg-gray-200 rounded"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CartSkeletonLoader;